<h1>Book Now</h1>

<div class="flex justify-content-center">
  @if (isLoading()) {
  <div class="progress-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
  }
  @else {
    <p-calendar
      class="max-w-full"
      [(ngModel)]="selectedDate"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [disabledDates]="disabledDates"
      (onSelect)="onSelect($event)"
      [inline]="true"
      [selectOtherMonths]="true">
    <ng-template pTemplate="date" let-date>
      <span [ngClass]="{'disabled': isDateDisabled(date)}" class="date">
        {{date.day}}
      </span>
    </ng-template>
  </p-calendar>
  }
</div>
<div class="flex justify-content-center mt-1  gap-5">
  <div><span class="available">&nbsp;&nbsp;&nbsp;&nbsp;</span> Available</div>
  <div><span class="unavailable">&nbsp;&nbsp;&nbsp;&nbsp;</span> Unavailable</div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button (click)="onBackClick()" label="BACK"></p-button>
  <p-button (click)="onNextClick()" [disabled]="!selectedDate" label="NEXT"></p-button>
</div>